__turbopack_context__.v({
  "add": "new-module-scss-module__MK8eUq__add",
  "link": "new-module-scss-module__MK8eUq__link",
});
